// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb-module--breadcrumb--1_aW7","navlist":"Breadcrumb-module--navlist--1vs7P"};